<script setup lang="js">
// import DarkModeSwitcher from '@/components/Dashboard/Header/DarkModeSwitcher.vue'
import DashboardHeaderUserDropdown from '@/components/Dashboard/Header/DashboardHeaderUserDropdown.vue'

const emit = defineEmits(['contactUsClicked'])
</script>

<template>
	<header id="dashboard_header"
			  class="sticky top-0 z-999 flex w-full bg-neutral drop-shadow-1"
	>
		<div class="flex flex-grow h-20 items-center justify-between shadow-2">

			<div class="flex items-center h-full w-full">
				<!-- Search bar -->
				<div v-if="false" class="flex relative w-full max-w-[50%] focus-within:z-10 pl-4 mr-9">
					<div class="absolute pointer-events-none inset-y-0 ml-9 flex items-center">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
							<path fill-rule="evenodd" clip-rule="evenodd"
									d="M8.99423 3.33366C5.83315 3.33366 3.27058 5.94533 3.27058 9.16699C3.27058 12.3887 5.83315 15.0003 8.99423 15.0003C12.1553 15.0003 14.7179 12.3887 14.7179 9.16699C14.7179 5.94533 12.1553 3.33366 8.99423 3.33366ZM1.63525 9.16699C1.63525 5.02486 4.92998 1.66699 8.99423 1.66699C13.0585 1.66699 16.3532 5.02486 16.3532 9.16699C16.3532 13.3091 13.0585 16.667 8.99423 16.667C4.92998 16.667 1.63525 13.3091 1.63525 9.16699Z"
									fill="#55565A" />
							<path fill-rule="evenodd" clip-rule="evenodd"
									d="M13.0359 13.2861C13.3552 12.9606 13.8729 12.9606 14.1922 13.2861L17.7491 16.9111C18.0684 17.2365 18.0684 17.7641 17.7491 18.0896C17.4298 18.415 16.912 18.415 16.5927 18.0896L13.0359 14.4646C12.7166 14.1391 12.7166 13.6115 13.0359 13.2861Z"
									fill="#55565A" />
						</svg>
					</div>

					<input type="text" name="search" autocomplete="off"
							 data-lpignore="true" placeholder="Type to search..."
							 class="block w-full h-8 ml-6 pl-10 text-grayscale-body text-sm outline-none border-none focus:ring-0 focus:rounded-lg focus:outline-1 focus:outline-primary-bold-hover disabled:cursor-default" />
				</div>

				<!-- Dark Mode Toggler -->
				<!--        <DarkModeSwitcher class="ml-auto mr-6"/>-->

				<div v-if="false" class="flex flex-row space-x-3 ml-auto mr-10">
					<!-- Alerts icon -->
					<div class="flex relative justify-center items-center hover:cursor-pointer bg-primary-subtlest rounded-full" @click="console.log('todo')">
						<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
							<path
								d="M18.0334 0.25C27.6451 0.25 35.4456 8.19245 35.4456 18C35.4456 27.8075 27.6451 35.75 18.0334 35.75C8.42196 35.7498 0.622314 27.8074 0.622314 18C0.622314 8.19259 8.42196 0.25023 18.0334 0.25Z"
								 stroke="#D8DFE4" stroke-width="0.5" />
						</svg>

						<div class="absolute inset-0 flex justify-center items-center z-10 bg-primary-subtlest rounded-full">
							<svg class="absolute left-6 bottom-6" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
								<circle cx="5.99988" cy="6" r="5" fill="#13B5EA" stroke="white" stroke-width="2" />
							</svg>
							<img src="@/assets/images/icon/bell.svg" alt="Bell" title="Message" />
						</div>
					</div>

					<!-- Messages icon -->
					<div class="flex relative justify-center items-center hover:cursor-pointer" @click="console.log('todo')">
						<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
							<path
								d="M18.0334 0.25C27.6451 0.25 35.4456 8.19245 35.4456 18C35.4456 27.8075 27.6451 35.75 18.0334 35.75C8.42196 35.7498 0.622314 27.8074 0.622314 18C0.622314 8.19259 8.42196 0.25023 18.0334 0.25Z"
								stroke="#D8DFE4" stroke-width="0.5" />
						</svg>

						<div class="absolute inset-0 flex justify-center items-center z-10 bg-primary-subtlest rounded-full">
							<svg class="absolute left-6 bottom-6" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
								<circle cx="5.99988" cy="6" r="5" fill="#F8971D" stroke="white" stroke-width="2" />
							</svg>
							<img src="@/assets/images/icon/chat-bubble.svg" alt="Chat" title="Chat" />
						</div>
					</div>
				</div>

				<!-- User Area -->
				<DashboardHeaderUserDropdown @contactUsClicked="emit('contactUsClicked')"/>
			</div>
		</div>
	</header>
</template>
